module.exports = __webpack_public_path__ + "static/media/image_36.e21fb308.png";